<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.pool_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.poolCreate"
    sbTooltip="{{'lang.pools.createPool' | translate}}"
  >
  </button>
  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>
</ng-container>

<!------------------------------

  Table Wrapper

------------------------------->

@let isExpanded = false;

<sb-table-wrapper-new
  headline="{{'lang.headlines.pools' | translate}}"
  [itemsData]="hierarchies"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'pools'"
  [iterateTableRows]="false">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>


  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th></th>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.devices' | translate }}
      </th>
      <th>
        {{ 'lang.globals.devicesProductive' | translate }}
      </th>
      <th class=" sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody>
    <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: hierarchies, level: 0 }">
    </ng-container>
    <tr *ngIf="dragToRoot" [attr.data-pool]="null" (drop)="onDrop($event)"
        (dragstart)="onDragStart($event)" (dragend)="onDragEnd($event)"
        (dragover)="onDragOver($event)">
      <td></td>
      <td>
        &nbsp;
      </td>
      <td>
        &nbsp;
      </td>
      <td>
        &nbsp;
      </td>
      <td>
        &nbsp;
      </td>
      <td>

      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>

<ng-template #recursiveListTmpl let-list="list" let-level="level">
  @for (item of list; track item.id) {
    <tr
      [attr.data-pool]="item?.id" (drop)="onDrop($event)" (dragstart)="onDragStart($event)"
      (dragend)="onDragEnd($event)" (dragover)="onDragOver($event)"
      [style.background]="isNumberEven(level) ? null : 'rgba(239, 239, 239, .5)'">
      <td>
        <div *ngPermissions="permissionService.Permission.pool_change_order" class="btn btn-hover-primary mr-3"
             (mousedown)="onmousedown($event)" (mouseup)="onmouseup($event)">
          <sb-icon icon="drag"></sb-icon>
        </div>
      </td>
      <td>
        <sb-icon *ngIf="item.children && item.children.length > 0 && showChildren.has(item?.id)"
                 [style.margin-left.px]="level"
                 [icon]="'minus'" class="cursor-pointer"
                 (click)="toggleShowChildren(item)"></sb-icon>
        <sb-icon *ngIf="item.children && item.children.length > 0 && !showChildren.has(item?.id)"
                 [style.margin-left.px]="level"
                 [icon]="'plus'" class="cursor-pointer"
                 (click)="toggleShowChildren(item)"></sb-icon>
        <sb-icon *ngIf="!(item.children && item.children.length > 0)" [style.margin-left.px]="level"
                 [icon]="'plus'" style="opacity: 0;"></sb-icon>
        &nbsp;
        {{ item.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <sb-comp-link firstLine
                        [title]="item.name"
                        [permission]="permissionService.Permission.pool_show"
                        [link]="util.RoutingID.devices"
                        [queryParams]="{'poolIds': getPoolId(item)}">
            ngbTooltip="{{ 'lang.globals.openDetails' | translate }}" container="body"
          </sb-comp-link>
          <sb-tags secondLine
                   *ngPermissions="[permissionService.Permission.tag_list]"
                   [tags]="item.tags"
                   [dtoType]="tagService.TaggableDTO.Pool" [dtoId]="item.id"></sb-tags>
        </sb-comp-name-wrapper>

      </td>
      <td>
        {{ item.countDevices }}
      </td>
      <td>
        {{ item.countDevicesProductive }}
      </td>
      <td class="tr sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="item.sbButtons ?? []"
        ></sb-split-button>

      </td>
    </tr>
    @if (item.children.length > 0 && showChildren.has(item?.id)) {
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: item.children, level: level + 25 }">
      </ng-container>
    }
  }
</ng-template>
